import { InjectionToken } from '@angular/core';

/** The application's version, as a chart's failure log names it; each application provides its own. */
export const CHART_APP_VERSION = new InjectionToken<string>('CHART_APP_VERSION', { factory: () => 'unknown' });
